import React from "react";
import { CloudUpload } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import {
  useGetCustomerFilesQuery,
  GetCustomerFiles,
  useDeleteCustomerDocMutation,
  CustomerDocumentTypes,
  Document
} from "@graphql";
import { SecondaryButton } from "@components";
import DocumentList from "@containers/DocumentList/DocumentList";

type Props = {
  id: string;
  onUpload: () => void;
  allowDelete?: boolean;
};

export function CustomerDocuments({ id, onUpload, allowDelete }: Props) {
  const { data, loading } = useGetCustomerFilesQuery({
    variables: {
      id
    }
  });
  const [deleteDoc] = useDeleteCustomerDocMutation();
  const handleDelete = (doc) => {
    deleteDoc({
      variables: {
        id: data.customerById._id,
        fileId: doc.FileRef.NodeID
      },
      refetchQueries: [GetCustomerFiles.OperationName]
    });
  };
  const docs = data?.customerById.documents || [];

  const isDisableOnDelete = (doc: Document) => {
    // Check if the document is a standing certificate
    // If allowDelete is true, do not disable the delete button
    if (
      allowDelete ||
      doc.DocumentType !== CustomerDocumentTypes.StandingCertificateForTR
    ) {
      return false;
    }

    const standingCertificateDocs = docs.filter(
      (x) => x.DocumentType === CustomerDocumentTypes.StandingCertificateForTR
    );

    // If there is only one standing certificate document, disable the delete button
    return standingCertificateDocs.length === 1;
  };

  return (
    <div>
      <div style={{ display: "flex", marginBottom: 16 }}>
        <SecondaryButton
          onClick={onUpload}
          variant="outlined"
          leftIcon={<CloudUpload />}
          style={{ marginLeft: "auto" }}
        >
          {locale.UploadFile}
        </SecondaryButton>
      </div>

      <DocumentList
        loading={loading}
        disabledOnDelete={isDisableOnDelete}
        groupBy={(d) => locale.customerDocumentTypes[d.DocumentType]}
        documents={docs}
        onDelete={handleDelete}
      />
    </div>
  );
}
